import { useHistory } from 'react-router-dom';
import PaginationJS from 'react-js-pagination';
import { Container } from './styles';

export interface IPagination {
  currentPage: number;
  total: number;
  perPage: number;
}

export const Pagination = ({ currentPage, total, perPage }: IPagination) => {
  const history = useHistory();

  function handleCurrentPageChange(page: number): void {
    const urlSearchParams = new URLSearchParams(window.location.search);
    urlSearchParams.set('page', String(page));
    history.push({
      pathname: history.location.pathname,
      search: urlSearchParams.toString(),
    });
  }

  if (total <= perPage) {
    return null;
  }

  return (
    <Container
      className="d-flex justify-content-center mt-4"
      aria-label="Page navigation example"
    >
      <PaginationJS
        activePage={currentPage}
        onChange={handleCurrentPageChange}
        totalItemsCount={total}
        itemsCountPerPage={perPage}
        pageRangeDisplayed={5}
        prevPageText="Anterior"
        nextPageText="Próxima"
        activeClass="item-paginate-active"
        disabledClass="item-paginate-disabled"
        itemClass="item-paginate"
        hideFirstLastPages
      />
    </Container>
  );
};
